import './boot';
import {ApplicationType} from '@Common/Enums';

(function startup(): void {
    let appName = ApplicationType.getName(altosoft.appId);
    let pageName = strings.pageNames[altosoft.pageType];
    if (altosoft.pageType === 'mtConsole' || altosoft.pageType === 'alertMessage') {
        appName = pageName;
        pageName = undefined;
    }
    const fullPageName = strings.pageNames.pageNameFormat.format(appName, pageName || '');
    strings.applicationName = fullPageName;
    document.title = fullPageName;
})();
